import { render, staticRenderFns } from "./people_list.vue?vue&type=template&id=73c0542e&scoped=true"
import script from "./people_list.vue?vue&type=script&lang=js"
export * from "./people_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0542e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c0542e')) {
      api.createRecord('73c0542e', component.options)
    } else {
      api.reload('73c0542e', component.options)
    }
    module.hot.accept("./people_list.vue?vue&type=template&id=73c0542e&scoped=true", function () {
      api.rerender('73c0542e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/performanceCalculation/views/result_statement/dealer_performance_report/form/people_list.vue"
export default component.exports